<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7.41 9L12 13.3302L16.59 9L18 10.3396L12 16L6 10.3396L7.41 9Z" fill="currentColor" />
  </svg>
</template>
